"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var getter_1 = require("./getter");
var decorator_1 = require("./decorator");
/**
 * A note for the user:
 *  Since TS is transpiled no type info is available at runtime,
 *  meaning that without a default orElse, you will get an
 *  EMPTY json object ({}) so things will be kind of broken.
 *
 * USE WITH EXTREME CAUTION
 *
 * @param root root object
 * @param path path to field
 * @param orElse should be provided or you will get an empty object
 * and things will be borked
 */
function objectOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = {}; }
    return lodash_1.merge({}, orElse, decorator_1.decorate(getter_1.getDefinedOrElse(root, path, orElse), decorators));
}
exports.objectOr = objectOr;
//# sourceMappingURL=objectOr.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/getters/objectOr.js
 ** module id = 2476
 ** module chunks = 0
 **/